// GatewayTokenVerifier.js
import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from './AuthContext';
import loadingImg from '../src/tables/static_files/Loading1.svg'
import './App.css'

const GatewayTokenVerifier = ({children}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {verifyGatewayToken, setUsdiHoldersData} = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        let token = queryParams.get('token');

        // 如果 URL 没有 token，则尝试从 localStorage 拿一下
        if (!token) {
            token = localStorage.getItem('gatewayToken');
        }

        if (!token) {
            navigate('/');
            return;
        }


        (async () => {
             const [isValid, fetchResponse] = await Promise.all([
                    verifyGatewayToken(token),
                    fetch('https://usdi-api-jlukzyz7wa-ew.a.run.app/usdi_holders_info_table_solana')
                ]);
            if (!isValid) {
                localStorage.removeItem("userEmail")
                localStorage.removeItem("emailUserWalletAddress")
                localStorage.removeItem("gatewayToken")
                localStorage.setItem("emailLogin", 'false')
                localStorage.removeItem("emailUserSelectedChain")
                localStorage.removeItem("isWhitelist")
                navigate('/');

            } else {
                   if (!fetchResponse.ok) {
                    console.error('Network response was not ok');
                } else {
                    const result = await fetchResponse.json();
                    // console.log("result!!!!",result)
                       //todo ， 也许可以优化
                    setUsdiHoldersData(result);
                }
                setLoading(false);
            }
        })();
    }, [location, navigate]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}>
                <img className="LoadingImage" src={loadingImg} alt="Loading"/>
            </div>
        );
    }

    return children;
};

export default GatewayTokenVerifier;
